import * as TASK from './tasks.constants';
import { ITask } from '../../models/';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

function buildTasksStoreItem(payload: ITask[]): StoreItem<ITask> {
    const dic = {};
    payload.forEach(element => {
        dic[element.guid] = element;
    });
    return {
        dictionary: dic,
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: null
    };
}

export function tasksReducer(state: StoreItem<ITask> = new StoreItem<ITask>(), action: { type: string, payload: any }) {
    let newState = state;
    if (action && action.type) {
        switch (action.type) {
            case TASK.TASK_ADD_SUCCESS:
            case TASK.TASK_LOAD_SUCCESS:
            case TASK.TASKS_LOAD_SUCCESS:
            case TASK.TASKS_DELETE_COMPLETED_SUCCESS:
                newState = buildTasksStoreItem(action.payload);
                break;
            case APPLICATION_DISCONNECTED:
                newState = new StoreItem<ITask>();
                break;
        }
    }
    return newState;
}